let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("99ZhX")).then(() => parcelRequire('2O4nn'));